module.exports = __webpack_public_path__ + "img/Vector_kifizetett_tamogatas.6c079f77.svg";